import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../../pages/Home/Home";
import Login from "../../pages/Login/Login";
import Signup from "../../pages/Signup/Signup";
import ForgetPass from "../../pages/ForgetPass/ForgetPass";
import SetupPassword from "../../pages/SetupPassword/SetupPassword";
import ResetOtp from "../../pages/ResetOtp/ResetOtp";

const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/setuppassword" element={<SetupPassword />} />
      <Route path="/recoveraccount" element={<ForgetPass />}></Route>
      <Route path="/recoveraccount/resetopt" element={<ResetOtp />}></Route>
      <Route
        path="/recoveraccount/setuppassword"
        element={<SetupPassword />}
      ></Route>
    </Routes>
  );
};

export default AllRoutes;
